module.exports = __webpack_public_path__ + "img/provider-details.f54d774d.webp";